/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgxPicaExifService as ɵa} from './lib/ngx-pica-exif.service';